import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function Faqs() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream px-4 pb-14 sm:px-5 sm:pb-24" data-id="element-47" data-mp="35652ddsqbd0x">
      <div className="mx-auto max-w-3xl" data-id="element-48" data-mp="357g292j200mr">
        <Reveal data-id="element-49" data-mp="3a5huoe2ddcaw">
          <SectionLabel data-id="element-50" data-mp="3a6139464qoc9">Tutto quello che serve sapere</SectionLabel>
          <h2 className="display mt-5 text-center text-[1.7rem] text-ink sm:text-[3.1rem]" data-id="element-51" data-mp="3f4cbxbkoussw">
            Domande frequenti
          </h2>
        </Reveal>

        <ul className="mt-8 space-y-2.5 sm:mt-11 sm:space-y-3" data-id="element-52" data-mp="3k3xd7snbzd8s">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`overflow-hidden rounded-2xl border-2 bg-white transition-colors duration-150 ease-snap ${isOpen ? 'border-orange/40' : 'border-ink/10'}`} data-id="element-53" data-mp="1ppo29i3hfoyk" data-mpi={index}>
                <h3 data-id="element-54" data-mp="2hbiiic8cwba4">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left sm:gap-4 sm:px-6 sm:py-5" data-id="element-55" data-mp="2hbqvs58e5ilu">
                    <span className="text-[15px] font-black leading-snug text-ink sm:text-base" data-id="element-56" data-mp="27jl1upykwr40">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-snap ${isOpen ? 'bg-orange' : 'bg-sand'}`} data-id="element-57" data-mp="3091unoq42a0r">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-snap ${isOpen ? 'rotate-45 text-white' : 'text-ink/60'}`} strokeWidth={4} aria-hidden="true" data-id="element-58" data-mp="2qbdx6r14eoew" />
                    </span>
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5 sm:px-6 sm:pb-6" data-id="element-59" data-mp="19xx9qh95ouya">
                    <p className="border-t-2 border-ink/10 pt-4 text-[15px] font-semibold leading-relaxed text-ink/65 sm:text-base" data-id="element-60" data-mp="1a09ybd9f63kb">
                      {faq.answer}
                    </p>
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}